export default "__VITE_ASSET__7JL3$NPR__"